<app-header-nav></app-header-nav>
<!-- begin::Body -->
<router-outlet></router-outlet>
<!-- end::Body -->
<app-quick-sidebar></app-quick-sidebar>

<telephony-main *ngIf="isTelephonyActivated"></telephony-main>
